<template>

  <div class="search-app__bar">

      <div class="search-app__input-group">
          <form :action="searchUrl" novalidate  @submit.prevent="submitSearch" ref="searchForm" class="suggestionsForm">
              <button
                class="search-app__btn search-app__enter"
                :aria-label="submitLabel"
              >
                  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Search">
                      <path
                          d="M28.8161 28.5716L22.1013 22.012M25.7289 13.4922C25.7289 20.1547 20.2 25.5557 13.3798 25.5557C6.55962 25.5557 1.03076 20.1547 1.03076 13.4922C1.03076 6.82972 6.55962 1.42871 13.3798 1.42871C20.2 1.42871 25.7289 6.82972 25.7289 13.4922Z"
                          stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
              </button>
              <input class="search-app__input" type="text" placeholder="What are you looking for?"
                  ref="attraqtSearchInput" name="q" @input="onInput" min="3" required />
          </form> <!-- end of form -->
          <button class="search-app__btn search-app__clear" v-on:click="onClearSearch" value="">
              Clear
          </button>

      </div>
      <button
        class="search-app__btn search-app__close"
        @click="onCloseModal"
        :aria-label="closeLabel"
      >
          <svg width="32" height="30" viewBox="0 0 32 30" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" :aria-label="closeLabel">
              <path d="M30.1955 1L1.53271 29" stroke="#333333" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              <path d="M1.53271 1L30.1955 29" stroke="#333333" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
          </svg>
      </button>
  </div>
</template>

<script>
import { getAttraqtLocaleAttributes } from '~/helpers/utils'

export default {
name: "SearchBar",
data() {
  return {
    searchingTerm: '',
    searchUrl: mint.routes.search
  };
},

computed: {

  /**
   * Get locale string for close button.
   * @returns {String}
   */
  closeLabel() {
    return mint.strings.accessibility.close
  },

  /**
   * Get locale string for search submit button.
   * @returns {String}
   */
  submitLabel() {
    return mint.strings.search.submit
  },
},

methods: {
  onInput: function (event) {
    this.$emit("termChange", event.target.value);
    this.searchingTerm  = event.target.value;
  },
  onClearSearch: function (event) {
    // this.onInput(event);
    this.$refs["attraqtSearchInput"].value = "";
    this.$emit("termChange", event.target.value);
  },
  onCloseModal() {
    this.$emit("onModalClose", 0);
  },


  submitSearch() {
    this.fetchData(this.searchingTerm);
  },

  fetchData(term) {
    if (this.getShopifyMerchandisingFlag()) {
      this.$refs.searchForm.submit();
    }

    var that = this;
    let env = mint.services.attraqt.instance

    /**
     * Set query parameters.
     */
    const queryParams = new URLSearchParams({
      'fh_location': '//mintvelvet/en_GB/',
      's': term,
      'date_time': this.formatDate(new Date()),
      'mv_channel': 'web',
      'mv_device': this.getDevice(),
      'fh_start_index': 0,
      'fh_view_size': 48,
      'fh_row_size': 4,
      'fh_sort_by': window.mint.services.attraqt.priceField,
      ...getAttraqtLocaleAttributes(),
    })

    let dataURL = {
      queryString: `https://query.published.${env}.fas.eu1.fredhopperservices.com/fredhopper/query?${queryParams.toString()}`,
    };

    let data = JSON.stringify(dataURL);
    fetch("/apps/attraqt/", {
      body: data,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      return response.json();
    }).then(function (data) {


      if (data.collection) {
        let urlToRedirect = mint.shop.localisedShopDomain + mint.routes.collections + '/' + data.collection.handle;
        window.location.href = urlToRedirect;
      } else if (data.page) {
        let urlToRedirect = mint.shop.localisedShopDomain + '/pages/' + data.page.handle;
        window.location.href = urlToRedirect;
      } else if (data.info.view == 'detail') {
        that.redirectToPDP(data.universes.universe[0]['items-section'].items.item[0]);
      } else  {
        that.$refs.searchForm.submit();
      }
    }).catch(function (error) {
      console.log(error);
    });
  },

  redirectToPDP(product) {
    product.attribute.forEach((obj)=>{
      let valueToSave = obj.value[0].value;
      switch (obj.name) {
        case('handle'):
          let urlToRedirect = mint.shop.localisedShopDomain + '/products/'+valueToSave;
          window.location.href = urlToRedirect;
      }
    })
  },

  getDevice() {
    const isMobile = /iPhone|Android/i.test(navigator.userAgent)
    const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(navigator.userAgent)

    if (isMobile) {
      return 'mobile'
    } else if (isTablet) {
      return 'tablet'
    } else {
      return 'desktop'
    }
  },

  padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  },

  formatDate(date) {

    return (
      [
        date.getFullYear(),
        this.padTo2Digits(date.getMonth() + 1),
        this.padTo2Digits(date.getDate()),
        this.padTo2Digits(date.getHours()),
        this.padTo2Digits(date.getMinutes()),
        this.padTo2Digits(date.getSeconds()),
      ].join('')
    );
  },

  /**
   * Return the state of the Shopify merchandising feature flag.
   * @returns {Boolean}
   */
  getShopifyMerchandisingFlag() {
    return mint?.flags?.shopifyMerchandising?.enable || false
  },


},
};
</script>